// Base categories with translation keys
export const getCategoriesWithTranslations = (t) => [
  { title: t("CATEGORIES.MEZ"), value: "mez", key: "MEZ" },
  {
    title: t("CATEGORIES.MEZ_KULONLEGESSEGEK"),
    value: "mezkulonlegessegek",
    key: "MEZ_KULONLEGESSEGEK",
  },
  {
    title: t("CATEGORIES.MEHESZETI_TERMEKEK"),
    value: "meheszeti-termekek",
    key: "MEHESZETI_TERMEKEK",
  },
  { title: t("CATEGORIES.EGYEB"), value: "egyeb", key: "EGYEB" },
  {
    title: t("CATEGORIES.VIRAGPOR_PROPOLISZ"),
    value: "viragpor-propolisz",
    key: "VIRAGPOR_PROPOLISZ",
  },
  { title: t("CATEGORIES.GYERTYA"), value: "gyertya", key: "GYERTYA" },
  {
    title: t("CATEGORIES.MEZES_CSOMAGOK"),
    value: "mezes-csomagok",
    key: "MEZES_CSOMAGOK",
  },
];

// Legacy export for backward compatibility (will be updated)
export const categories = [
  { title: "Méz", value: "mez" },
  { title: "Méhészeti Termékek", value: "meheszeti-termekek" },
  { title: "Egyéb", value: "egyeb" },
  { title: "Virágpor/Propolisz", value: "viragpor-propolisz" },
  { title: "Gyertya", value: "gyertya" },
  { title: "Mézes csomagok", value: "mezes-csomagok" },
];
